function getSubdomain(hostname: string) {
  const subDomainIndex = hostname.indexOf('.')
  if (subDomainIndex <= 0) return 'localhost'

  return hostname.substring(0, subDomainIndex)
}

const environment = process.env.REACT_APP_ENVIRONMENT

function getEnvironment() {
  if (environment) {
    return environment
  }

  let subDomain = getSubdomain(window.location.hostname) || 'localhost'
  // TODO this should probably throw an exception if localhost and
  // this is not running locally
  subDomain = subDomain === 'localhost' ? 'demo' : subDomain

  return subDomain
}

export { getEnvironment, getSubdomain }
